module.exports = __webpack_public_path__ + "img/HQ-PA10W1UH_ALL.dff4a529.jpg";